import {useEffect, useState} from "react";
import moment from "moment-timezone";

const AnalysisDetails = (props) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [sortedResult, setSortedResult] = useState([]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getImageUrl = (item) => {
    let imgUrl = "/images/meta.png";
    switch (
      item.model_id
        .replace(/_/g, " ")
        .split("/")
        .pop()
        .split(".")[0]
        .toUpperCase()
    ) {
      case "AMAZON":
        imgUrl = "/images/amazon.webp";
        break;
      case "META":
        imgUrl = "/images/meta.png";
        break;
      case "MISTRAL":
        imgUrl = "/images/mistral.png";
        break;
      case "COHERE":
        imgUrl = "/images/cohere.png";
        break;
      case "AI21":
        imgUrl = "/images/ai21labs.jpeg";
        break;
      default:
        break;
    }
    return imgUrl;
  };

  useEffect(() => {
    if (props.selectedDocument.accuracy_evaluation) {
      setSortedResult(
        props.selectedDocument.accuracy_evaluation.sort((a, b) =>
          a.model_id.split("/").pop().localeCompare(b.model_id.split("/").pop())
        )
      );
    }
  }, [props.selectedDocument]);

  return (
    <div className="w-full flex p-4 mb-20">
      <div className="bg-white rounded-2xl p-4 sm:p-8 w-full border border-gray-200">
        <h1 className="text-3xl text-center text-gray-500 mb-8 tracking-tight">
          {props.selectedDocument?.session_id?.toUpperCase() ||
            "No Session Selected"}
        </h1>

        <div className="flex flex-col">
          <h4 className="text-left font-bold text-gray-500">User Input</h4>
          <h6 className="text-left text-gray-400 mb-8">
            {props.selectedDocument?.user_input || "No User Input Available"}
          </h6>
        </div>

        <div className="flex flex-col">
          <h4 className="text-left font-bold text-gray-500">
            Original Response
          </h4>
          <h6 className="text-left text-gray-400 mb-8">
            {props.selectedDocument?.original_response ||
              "No Original Response Available"}
          </h6>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6 text-gray-700 text-sm sm:text-base">
          <div>
            <p className="text-left font-bold text-gray-500">Knowledge ID</p>
            <p className="text-left text-gray-400">
              {props.selectedDocument?.knowledgebase_id}
            </p>
          </div>

          <div>
            <p className="text-left font-bold text-gray-500">Last Updated</p>
            <p className="text-left text-gray-400">
              {moment
                .tz(
                  new Date(props.selectedDocument?.last_updated),
                  "America/Los_Angeles"
                )
                .format("MM-DD-YYYY hh:mm A")}
            </p>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          {sortedResult?.length > 0 ? (
            sortedResult.map((item, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden shadow-sm"
              >
                {/* Accordion Header */}
                <button
                  className="flex justify-between items-center w-full px-5 py-4 text-left bg-gray-50 hover:bg-gray-100 focus:outline-none transition-colors duration-200"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                >
                  <div className="flex justify-between w-[90vw]">
                    <div className="flex items-center w-3/5">
                      <img
                        className="w-6 h-6 mr-3"
                        src={getImageUrl(item)}
                        alt={item.model_id}
                      />
                      <span className="text-lg font-normal text-gray-700 mr-4">
                        {
                          item.model_id
                            .replace(/_/g, " ")
                            .split("/")
                            .pop()
                            .split(".")[1]
                            .split(":")[0]
                        }
                      </span>
                    </div>

                    <span className="text-lg font-semibold text-gray-700 w-2/5">
                      Evaluation Result:{" "}
                      <span
                        className={`font-bold ${
                          item.evaluation_result === "match"
                            ? "text-green-600"
                            : item.evaluation_result === "partial_match"
                            ? "text-yellow-600"
                            : "text-red-600"
                        }`}
                      >
                        {item.evaluation_result
                          .replace(/_/g, " ")
                          .toUpperCase()}
                      </span>
                      <span
                        className={`ml-2 font-bold ${
                          item.evaluation_result === "match"
                            ? "text-green-600"
                            : item.evaluation_result === "partial_match"
                            ? "text-yellow-600"
                            : "text-red-600"
                        }`}
                      >
                        | {item.confidence * (100).toFixed(2)}%
                      </span>
                    </span>
                  </div>

                  <div className="flex w-[10vw] justify-end">
                    <svg
                      className={`w-6 h-6 text-gray-600 transform transition-transform duration-300 ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </div>
                </button>

                {/* Accordion Content */}
                {openIndex === index && (
                  <div className="p-5 bg-white border-t border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6 text-gray-700 text-sm sm:text-base">
                      <div>
                        <p className="text-left font-bold text-gray-500">
                          Model:
                        </p>
                        <p className="text-left text-gray-400">
                          {" "}
                          {
                            item.model_id
                              .replace(/_/g, " ")
                              .split("/")
                              .pop()
                              .split(".")[0]
                          }{" "}
                          {
                            item.model_id
                              .replace(/_/g, " ")
                              .split("/")
                              .pop()
                              .split(".")[1]
                              .split(":")[0]
                          }
                        </p>
                      </div>

                      <div>
                        <p className="text-left font-bold text-gray-500">
                          Confidence:
                        </p>
                        <p className="text-left text-gray-400">
                          {item.confidence.toFixed(2)}
                        </p>
                      </div>

                      <div className="md:col-span-2">
                        <p className="text-left font-bold text-gray-500">
                          Model Response:
                        </p>
                        <p className="text-left text-gray-400">
                          {item.tester_response}
                        </p>
                      </div>

                      <div className="md:col-span-2">
                        <p className="text-left font-bold text-gray-500">
                          Timestamp:
                        </p>
                        <p className="text-left text-gray-400">
                          {moment
                            .tz(new Date(item.timestamp), "America/Los_Angeles")
                            .format("MM-DD-YYYY hh:mm A")}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 italic py-4">
              No evaluation data available.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalysisDetails;
